const TEN_MINUTES = 600000

export const sessionRefreshTime = process.env.REACT_APP_SESSION_REFRESH_TIME
  ? +process.env.REACT_APP_SESSION_REFRESH_TIME
  : TEN_MINUTES
